//Utils for use with @atlassian/pragmatic-drag-and-drop
import { once } from "@atlaskit/pragmatic-drag-and-drop/once";

/**
 * Returns `true` if a `Safari` browser.
 * Returns `true` if the browser is running on iOS (they are all Safari).
 * */
export const isSafari = once(function isSafari() {
  if (process.env.NODE_ENV === "test") {
    return false;
  }

  const { userAgent } = navigator;
  return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});

export const itemKey = Symbol("item");
export const getItemData = ({ item, index, instanceId }) => {
  return {
    [itemKey]: true,
    item,
    index,
    instanceId,
  };
};

export const isItemData = (data) => {
  return data[itemKey] === true;
};

export const getItemPosition = ({ index, items }) => {
  if (items.length === 1) {
    return "only";
  }

  if (index === 0) {
    return "first";
  }

  if (index === items.length - 1) {
    return "last";
  }

  return "middle";
};

export const getItemRegistry = () => {
  const registry = new Map();

  function register({ itemId, element }) {
    registry.set(itemId, element);

    return function unregister() {
      registry.delete(itemId);
    };
  }

  const getElement = (itemId) => {
    return registry.get(itemId) ?? null;
  };

  return { register, getElement };
};

export const defaultItems = [
  {
    id: "task-1",
    label: "Organize a team-building event",
  },
  {
    id: "task-2",
    label: "Create and maintain office inventory",
  },
  {
    id: "task-3",
    label: "Update company website content",
  },
  {
    id: "task-4",
    label: "Plan and execute marketing campaigns",
  },
  {
    id: "task-5",
    label: "Coordinate employee training sessions",
  },
  {
    id: "task-6",
    label: "Manage facility maintenance",
  },
  {
    id: "task-7",
    label: "Organize customer feedback surveys",
  },
  {
    id: "task-8",
    label: "Coordinate travel arrangements",
  },
];
